export default __webpack_public_path__ + "static/media/MishHero2.f939282b.png";